<style scoped>
.form-box {
  text-align: left;
  padding: 20px 15px;
  background: #fff;
  margin: 15px;
  border-radius: 6px;
}
.form-list {
  overflow: hidden;
  /* border-bottom: 1px solid rgb(187, 186, 186); */
}
.top-line {
  border-top: 1px solid rgb(187, 186, 186);
  padding-top: 20px;
}
.title {
  overflow: hidden;
}
.box-line {
  float: left;
  margin-right: 5px;
  display: inline-block;
  width: 4px;
  height: 17px;
  background: #4fa1a4;
}
.fontC-409EFF {
  cursor: pointer;
  text-decoration: underline;
}
.sure-btn {
  width: 50%;
  color: #fff;
  background: #4fa1a4;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
/deep/.el-table .el-radio__label {
  display: none;
}
.select-btn {
  width: 70%;
  height: 70px;
  margin-left: 15%;
  line-height: 70px;
  border: 1px solid grey;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
}
.active {
  color: #fff;
  background: #4fa1a4;
  border: none;
}
.designee {
  padding: 3px 15px 6px 15px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 30px;
}
.title-line {
  display: inline-block;
  float: left;
  width: 4px;
  height: 20px;
  background: #4fa1a4;
  padding-top: 3px;
  margin-right: 5px;
}
.bottom-box {
  height: 5px;
}
.choose-person {
  display: inline-block;
  width: 97px;
  text-align: right;
}
.select-name {
  display: inline-block;
  max-width: 97px;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<template>
  <div class="contain" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="form-box">
      <p class="mb30">
        <b class="font-S16">{{ meetingTitle }}</b
        ><span>（{{ tenantName }}）</span>
      </p>
      <div class="form-item mb20">
        <span class="mr15"><span :class="departmentData == '' || departmentData == null ? 'title-line' : 'title-line mt6'"></span> 应用部门</span
        ><span class="designee mb20" v-show="departmentData !== '' || departmentData !== null" v-for="(item,index) in departmentData" :key="index"
          ><span class="select-name">{{ item.organisationName }}</span>
          <span @click="delDepartmentSingle(index)" class="ml10 cursor-sty font-S19">×</span></span
        ><a class="fontC-409EFF ml15" @click="toSelectPerson('D')">{{
          departmentData == '' || departmentData == null ? '选择部门' : '修改部门'
        }}</a>
      </div>
      <!-- <p class="mb20"><span class="title-line"></span> <span class="mr15">应用部门</span><a class="fontC-409EFF text-line ml30 cursor-sty" @click="addNode()">选择部门</a></p>
         -->
    </div>
    <div class="form-box mt15" v-for="(item, index) in processList" :key="index">
      <div class="form-list">
        <p class="title mb30">
          <span class="mr15"><span class="title-line"></span> 审批节点 {{ index + 1 }}</span>
          <a class="fontC-red text-line ml100 cursor-sty" v-if="index == 0 && processList.length < 10" @click="addNode()"
            >+添加更多节点</a
          >
          <a class="fontC-409EFF ml100" v-if="index !== 0" @click="deleteNode(item.guid, index)">删除节点</a>
        </p>
        <div class="form-item mb20">
          <span class="choose-person"><span class="fontC-red mr5">*</span><span class="mr15">选择审批人</span></span>
          <el-radio v-model="item.flowNodeType" label="1">指定人</el-radio>
          <el-radio v-model="item.flowNodeType" label="2">直接上级</el-radio>
        </div>
        <div class="form-item mb20" v-if="item.flowNodeType == '1'">
          <span class="choose-person"> <span class="fontC-red mr5">*</span><span class="mr15">指定人</span></span
          ><span class="designee" v-if="item.approveStaffName !== null && item.approveStaffName !== ''">{{
            item.approveStaffName
          }}</span
          ><a class="fontC-409EFF" @click="toSelectPerson(index)">{{
            item.approveStaffName == null || item.approveStaffName == '' ? '选择人员' : '修改人员'
          }}</a>
        </div>
      </div>
    </div>
    <div class="form-box mt15">
      <div class="form-list">
        <p class="mb20"><span class="title-line"></span> <span class="mr15">最后抄送人</span></p>
        <div class="form-item mb20">
          <span class="mr15 ml15">选择抄送人 </span
          ><span class="designee mb20" v-show="tableCarbon !== '' || tableCarbon !== null" v-for="(item,index) in tableCarbon" :key="index" 
            ><span class="select-name">{{ item.staffName }}</span><span @click="delCarbon(index)" class="ml10 cursor-sty font-S19" >×</span></span
          ><a class="fontC-409EFF ml15" @click="toSelectPerson('Y')">{{
            tableCarbon == '' || tableCarbon == null ? '选择人员' : '修改人员'
          }}</a>
        </div>
      </div>
      <el-button type="info" class="mb20 mt30 pl40 pr40" @click="submit()">提 交</el-button>
    </div>
    <div class="bottom-box"></div>
    <!-- 公司列表 -->
    <el-dialog title="选择组织" :visible.sync="visible1" width="36%" top="10%" center>
      <div>
        <p class="ml15f mb30">请选择审批人所在的组织</p>
        <p v-if="approvalerList == null || approvalerList == ''">暂无组织</p>
        <p
          class="select-btn"
          v-for="(item, index) in approvalerList"
          :key="index"
          @click="selectTenant(item.guid, index)"
          :class="{ active: index == mark }"
        >
          <b>选择【</b>{{ item.tenantName }}<b>】组织</b>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible1 = false">取 消</el-button>
        <el-button type="info" @click="sureCompany()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 指定审批人 -->
    <el-dialog title="选择人员" :visible.sync="visible2" width="60%" top="6%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
       
            <el-input style="margin-bottom:10px;margin-right:10px;" v-model="page.staffName" class="ipt-sty fontC-bbb mt15 " placeholder="请输入人员"></el-input>
            <el-button size="medium" type="info" @click="searchPerson">搜索</el-button>
            <!-- <p class="fontC-bbb">选择人员</p> -->
            <el-table :data="tableData" v-loading="tableLoading" border height="240px" style="width: 100%">
              <el-table-column label="选择" width="60" header-align="center" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-radio v-model="radio" :label="scope.row.guid" @change.native="radioChange(scope.row)"
                    >{{ select }}
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="staffName"
                label="名称"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="组织"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                width=""
                prop="positionNames"
                label="岗位"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              small
              class="pt pb back-color-fff t-center"
              background
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="page.totalRows"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="surePerson()">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="visible3" width="60%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick1"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              v-loading="tableLoading"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
    <!-- 选择抄送人 -->
    <el-dialog title="选择抄送人" :visible.sync="visible4" width="60%" top="6%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <el-input style="margin-bottom:10px;margin-right:10px;" v-model="page.staffName" class="ipt-sty fontC-bbb mt15 " placeholder="请输入人员"></el-input>
            <el-button size="medium" type="info" @click="searchPerson">搜索</el-button>
            <el-table
              :data="tableData"
              @selection-change="handleSelectionChange"
              v-loading="tableLoading"
              ref="dataTable"
              :row-key="
                (row) => {
                  return row.guid;
                }
              "
              border
              height="240px"
              style="width: 100%"
            >
              <el-table-column
                type="selection"
                width="60"
                header-align="center"
                align="center"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="staffName"
                label="名称"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="组织"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                width=""
                prop="positionNames"
                label="岗位"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              small
              class="pt pb back-color-fff t-center"
              background
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="page.totalRows"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible4 = false">取消</el-button>
        <el-button size="medium" type="info" @click="carbonSure()">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      meetingTitle: '',
      tenantName: '',
      radio: '',
      select: '',
      radioSelect: '', //选中的数据赋值给它
      radioIndex: '',
      mark: 0,
      tenantGuid: '',
      processList: [{ flowNodeType: '2', approveStaffName: '', approveStaffGuid: '', ccGuids: '', orderNum: 1 }],
      visible1: false,
      visible2: false,
      visible3: false,
      visible4:false,
      visibleType: 0,
      tableLoading: false,
      filterText: '',
      areaData: [],
      fullscreenLoading: false,
      carbon: '',
      carbonGuid: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      value: '',
      typeState: '1',
      addState: 0,
      approvaler: '',
      approvalerList: [],
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        bizState: 'Y',
        organisationGuid: '',
        staffName:null
      },
      departmentData:[],
      departmentList: [],
      area: [],
      delList: [],
      tableCarbon:[],
      multipleSelection:[],
      tenantList:[],
    };
  },
  watch: {
    filterText(val) {
        this.$refs.tree.filter(val);
    },
  },
  created() {
    this.meetingTitle = this.$route.query.flowName;
    this.tenantName = this.$route.query.tenantName;
    if(this.$route.query.ruleGuid){
      this.getData();
    }
    if(sessionStorage.organisations){
      this.departmentData = JSON.parse(sessionStorage.organisations);
      this.departmentList = JSON.parse(sessionStorage.organisations);
      console.log(this.departmentData)
    }
    if(this.$route.query.tenantGuid == localStorage.guid){
      this.tenantList = [{tenantName:this.$route.query.tenantName,guid:this.$route.query.tenantGuid}]
    }else{
      this.tenantList = [{tenantName:this.$route.query.tenantName,guid:this.$route.query.tenantGuid},{tenantName:JSON.parse(localStorage.userInfo).tenantName,guid:localStorage.guid}]
    }
    
  },
  methods: {
    searchPerson(){
      this.getStaff();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    getData() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/approve/data/get-flow-node?guid=` +
            self.$route.query.ruleGuid 
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data !== null) {
              self.processList = res.data.data;
              self.processList.sort((n1, n2) => {
                return n1.orderNum - n2.orderNum;
              });
              let ccGuids = JSON.parse(self.processList[0].ccGuids.replace(/name/g,"staffName"));
              self.tableCarbon = ccGuids;
              self.addState = 1;
            } else {
              self.addState = 0;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //删除审批人
    delCarbon(index) {
      let self = this;
      self.tableCarbon.splice(index, 1)
    },
    //添加节点
    addNode() {
      let self = this;
      let addList = {
        approveStaffName: '',
        flowNodeType: '1',
        approveStaffGuid: '',
        ccGuids: '',
        orderNum: self.processList.length + 1,
      };
      self.processList.push(addList);
    },
    //获取组织
    getOrganisation() {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + self.tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    //查询人员
    getStaff() {
      let self = this;
      if(!this.page.tenantGuid) return;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records;
          if(self.typeState == '2' && self.$route.query.ruleGuid && res.data.data.records !== null){
            res.data.data.records.forEach(k=>{
              this.$nextTick(() => { 
                this.$refs.dataTable.toggleRowSelection(k,false);
              })
              self.tableCarbon.forEach(i=>{
                if(i.guid == k.guid){
                  self.multipleSelection.push(k);
                  this.$nextTick(() => { 
                    this.$refs.dataTable.toggleRowSelection(k,true);
                  })
                }
                    
              })
            })
          }
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取公司
    // getApprovalOrganization() {
    //   let self = this;
    //   let query = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     enterpriseCates: ['010201', '9901','0101'],
    //   };
    //   self.api.postJson('/ms-user-scm-service/tenant/data/get', query).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.approvalerList = res.data.data.records;
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //删除节点
    deleteNode(guid, index) {
      let self = this;
      // if (self.processList[index].guid) {
      //   self.api.postJson('/ms-flow-approval-service/flow/data/delete-flow-note?guid=' + guid).then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       self.$message.success('删除成功');
      //       self.getData();
      //     } else {
      //       self.$message.error(res.data.msg);
      //     }
      //   });
      // } else {
        console.log(self.processList)
        self.processList.splice(index, 1);
        self.$message.success('删除成功');
      // }
    },
    //点击选择组织
    selectTenant(guid, index) {
      let self = this;
      if (index == self.mark) {
        self.mark = index;
      } else {
        self.mark = index;
        self.tenantGuid = guid;
      }
    },
    //选择公司弹窗
    toSelectPerson(type) {
      let self = this;
      self.filterText = ''
      self.page.staffName = null;
      self.page.pageIndex = 1;
      self.page.totalRows = 0;
      self.tableData = [];
      if (type == 'Y') {//抄送人
        self.approvalerList = self.tenantList;
        self.typeState = '2';
        self.visible1 = true;
      } else if (type == 'D') {//部门
        self.typeState = '3';
        self.visible3 = true;
        self.tenantGuid = self.$route.query.tenantGuid;
        self.getOrganisation();
      } else { //人员
        self.typeState = '1'; 
        self.radioIndex = type;
        self.visible2 = true;
 
        self.tenantGuid = self.$route.query.tenantGuid;
        self.getOrganisation();
      }
      // self.getApprovalOrganization();
    },
    //确定选择公司
    sureCompany() {
      let self = this;
      if (self.tenantGuid == '') {
        self.tenantGuid = self.approvalerList[0].guid;
      }
      if (self.typeState == '1') {
        self.visible2 = true;
      } else if (self.typeState == '2') {
        self.visible4 = true;
      } else {
        self.visible3 = true;
      }
      console.log(self.tenantGuid);
      self.getOrganisation();
      self.areaData = [];
      self.tableData = [];
      self.visible1 = false;
      // self.radioSelect = '';
      // self.radio = '';
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    handleNodeClick(data) {
      this.page.organisationGuid = data.guid;
      this.page.tenantGuid = data.tenantGuid;
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.getStaff();
      console.log(data);
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      let item = {
        guid: data.guid,
        organisationName: data.organisationName,
      };
      // self.area = []; 
      self.area.push(JSON.stringify(item));    
      self.area = self.unique(self.area);
      self.departmentList = [];
      self.area.forEach(function (i) {
        self.departmentList.push(JSON.parse(i));
      });
      console.log(self.departmentList);
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    //选择抄送人
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },
    //确定选择抄送人
    carbonSure(){
      let self = this;
      self.tableCarbon = self.multipleSelection;
      self.visible4 = false;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index){
      this.departmentData.splice(index,1);
      this.departmentList = this.departmentData;
      this.area.splice(index,1)
    },
    //确定选择部门
    departmentSure(){
      this.departmentData = this.departmentList;
      console.log(this.departmentData)
      this.visible3 = false;
    },
    radioChange(row) {
      let self = this;
      self.radioSelect = row;
    },
    //选择人员确定
    surePerson() {
      let self = this;
      if (self.typeState == '2') {
        self.carbon = self.radioSelect.staffName;
        self.carbonGuid = self.radioSelect.guid;
      } else {
        self.processList[self.radioIndex].approveStaffName = self.radioSelect.staffName;
        self.processList[self.radioIndex].approveStaffGuid = self.radioSelect.guid;
      }
      self.visible2 = false;
    },
    //提交
    submit() {
      let self = this;
      for (let i = 0; i < self.processList.length; i++) {
        if (self.processList[i].flowNodeType == '1' && self.processList[i].approveStaffGuid == '') {
          self.$message.warning('审批人不能为空！');
          return false;
        }
      }
      if(self.tableCarbon !==null){
        var cc = [];
        self.tableCarbon.forEach(i=>{
          let item = {
            guid:i.guid,
            name:i.staffName
          }
          cc.push(item)
        })
      }
      var processList = JSON.parse(JSON.stringify(self.processList))
      processList.map((item) => {
        delete item.approveStaffName;
        item.ccGuids = JSON.stringify(cc);
        if (item.flowNodeType == '2') {
          item.approveStaffGuid = '';
          item.approveStaffName = '';
        }
      });
      if(self.departmentData !== null){
        var departmentData = []
        self.departmentData.forEach(item=>{
          departmentData.push(item.guid)
        })
      }
      let query = {
        guid:self.$route.query.ruleGuid ? self.$route.query.ruleGuid : '',
        tenantGuid: this.$route.query.tenantGuid,
        flowTemplateGuid: self.$route.query.flowTemplateGuid,
        organisationGuids:departmentData,
        details: processList,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/add-flow-rule`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('提交成功！');
          self.$router.push({
            path: '/ruleSetting',
            query:{
               productGuid:this.$route.query.productGuid,
              flowTemplateGuid: this.$route.query.flowTemplateGuid,
              tenantGuid: this.$route.query.tenantGuid,
              flowName: this.$route.query.flowName,
              tenantName: this.$route.query.tenantName,
              
            }
          });
          self.getData();
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      }).catch(() => {
        self.$message.success('接口异常！');
        self.fullscreenLoading = false;
      });
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getStaff();
    },
  },
};
</script>